<template>
  <div>
    <Teleport to="#settings-group-header">
      <T>Геокодирование</T>
    </Teleport>  

    <Teleport to="#settings-group-actions">
      <!-- <v-tabs v-model="tab">
        <v-tab test-tag="tag-268"><T>Провайдер геоданных</T></v-tab>
        <v-tab test-tag="tag-269"><T>Зоны доставки</T></v-tab>
      </v-tabs> -->
      <v-btn test-tag="tag-266"
        text
        color="primary"
        @click="save"
        :loading="loading"
        :disabled="loading"
      >
        <v-icon>mdi-content-save</v-icon>
        <T>Сохранить</T>
      </v-btn>
    </Teleport>


    <GeocoderParams :config="$store.getters.local_refs.geocoding" :loading="loading" ref="geo" @desabled="v => bas=v"/>
    <hr />
    <DeliveryZones :loading="loading" ref="zone" :config="$store.getters.local_refs" :disabled="!bas" />


    
    

  </div>
</template>

<script>
import Teleport from 'vue2-teleport'

import DeliveryZones from '../../components/settings/delivery_zones'

import GeocoderParams from '../../components/settings/geocoding'

// import L from 'leaflet'
// import {latLng} from 'leaflet'
// import {LMap, LTileLayer} from 'vue2-leaflet'

export default {
  data: () => ({
    loading: false,
    local_geocoding: null,
    keycrutch: false,
    bas: null
    // tab: 0,
    // zoom: 13,
    // center: latLng(47.41322, -1.219482),
    // attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
  }),
  methods: {
    async save(){
      this.loading = true
      try {
        let geo = this.$refs.geo.submit()
        let zone = this.$refs.zone.submit().geocoding

        let new_config = {
          geocoding: {
            ...geo,
            zones: zone.zones,
            restaurant_address: zone.restaurant_address
          }
        }
        
        await this.$store.dispatch('updateLocalRefs', new_config)

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Изменения сохранены'),
          message_class: 'success'
        })

      } catch (e) {
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: `${e.message}`,
          message_class: 'error'
        })
        this.loading = false
      } finally {
        this.loading = false
      }
    }
    // setCenter(){
    //   this.center = latLng(54.991494, 82.912764);
    // }
  },
  mounted() {
    this.local_geocoding = JSON.parse(
      JSON.stringify(this.$store.getters.local_refs.geocoding)
    )

    this.keycrutch = this.local_geocoding.enabled
  },
  components: {
    Teleport,
    GeocoderParams,
    DeliveryZones
    // LMap,
    
    // LTileLayer
  }
}
</script>

<style>
hr {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 10px 0;
}

.leaflet-attribution-flag {
  display: none !important;
}
</style>